import { hasAccess } from '@/libs/userAbility/userAbilityChecker';
import store from '@/store';
// import { GET_USER, SUCCESS } from '@/store/constants';
// import { USER_USER_ALL_ROLES, USER_USER_LOADED } from '@/store/getters';
// import { Action, Getter } from 'vuex-class';

const commentNode = (el, vnode) => {
    const comment = document.createComment(' ');

    Object.defineProperty(comment, 'setAttribute', {
        value: () => undefined
    });

    vnode.text = ' ';
    vnode.elm = comment;
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;
    vnode.data.directives = undefined;

    if (vnode.componentInstance) {
        vnode.componentInstance.$el = comment;
    }

    if (el.parentNode) {
        el.parentNode.replaceChild(comment, el);
    }
};

class PluginStore {
    constructor (Vue) {
        this.vm = new Vue({
            data () {
                return {
                    
                    allRoles: store.getters['profile'].allRoles,
                    loaded: store.getters['profile']
                };
            },
            created () {
                this.subscribeOnUpdates();
            },
            methods: {
                subscribeOnUpdates () {
                    store.subscribe(({ type, payload }) => {
                        if (type === 'setProfile') {
                            if (payload) {
                                this.allRoles = payload.allRoles;
                                this.loaded = true;
                            }
                        }
                    });
                },
                checkRole (role) {
                    const { loaded } = this;
                    return new Promise(resolve => {
                        if (loaded) {
                            resolve(hasAccess(role, this.allRoles));
                        } else {
                            store.subscribe(({ type }) => {
                                if (type === 'setProfile') {
                                    resolve(hasAccess(role, this.allRoles));
                                }
                            });
                        }
                    });
                }
            }
        });
    }

    get allRoles () {
        return this.vm.$data.allRoles;
    }
}

const RoleAccessPlugin = {
    install (Vue) {
        const pluginStore = new PluginStore(Vue);
        Vue.directive('access-level',
            function (el, binding, vnode) {
                const allRoles = pluginStore.allRoles;
                const role = binding.value;
                if (!hasAccess(role, allRoles)) {
                    commentNode(el, vnode);
                } 
            }
        );

        Vue.prototype.$hasRole = role => pluginStore.vm.checkRole(role);
    }
};

export default RoleAccessPlugin;
